import React, { useState, useRef, useEffect } from 'react';
import { lang } from '../../generales/traduction';
import { useFetch } from '../../../hooks/useFetch';
import { capitalizeFirstLetter } from '../../../utils/utils';
import Action from '../../Action';
import MultiSelector from '../../MultiSelector';
import InputForm from "../../generales/InputForm";

const FilterPanel = ({
  isOpen, severityFilter, setSeverityFilter,
  statusFilter, techFilter, groupFilter, zoneFilter,
  ackFilter, ticketFilter, tipoFilter, searchTerm,
  setSearchTerm, setStatusFilter, setTechFilter,
  setGroupFilter, setZoneFilter, setAckFilter, setTipoFilter,
  setTicketFilter, technologies_catalog, groups_catalog,
  setShowCorrelationsFO, setShowCorrelationsMO,
  showCorrelationsFO, showCorrelationsMO,
  zona_catalog, filters, onFilterChange, yourData, buscar_cis,
  setManttoData, ManttoData, handleShowPopup, languaje, mode,
  user, dataUsers, devices, server, setRegisterIsValid,
  groupSelected, setData, loading, setLoading, setError,
  setEditActive, editActive, closCreateCisModal
}) => {

  // ── Toda la lógica original intacta ──
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: -300, y: 50 });
  const offset = useRef({ x: 0, y: 0 });

  const handleClearFilters = () => {
    const defaultFilters = {
      searchTerm: '', severities: [], statuses: ['PROBLEMA'],
      techs: [], groups: [], zones: [], ack: null, ticket: null,
    };
    onFilterChange && onFilterChange(defaultFilters);
  };

  const handleMouseDown = (e) => {
    if (e.target.closest('button, input, .tag, .options-dropdown div')) return;
    setIsDragging(true);
    const panel = e.currentTarget;
    offset.current.x = e.clientX - panel.offsetLeft;
    offset.current.y = e.clientY - panel.offsetTop;
  };
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    var newX = e.clientX - offset.current.x;
    var newY = e.clientY - offset.current.y;
    if (newX > -250) newX = -250;
    if ((newY + 500) > window.innerHeight) newY = window.innerHeight - 500;
    setPosition({ x: newX, y: newY });
  };
  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const [loadingM, setLoadingM] = useState(false);
  const [IpValid, setIpValid] = useState(true);
  const [LatValid, setLatValid] = useState(true);
  const [LonValid, setLonValid] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [msgError, setMsgError] = useState("");
  const dataBrands = useFetch('cassia/brands', '', '', 'GET', server);
  const [dataModels, setDataModels] = useState({ data: [], loading: true, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "search") { setSearchTerm(value); return; }
    if (name === "criticality") {
      setManttoData(p => ({ ...p, [name]: value === "" ? 0 : parseInt(value) })); return;
    }
    if (name === "host") {
      setManttoData(p => ({ ...p, [name]: value.trimStart() })); return;
    }
    if (name === "status") {
      setManttoData(p => ({ ...p, [name]: (value == 0) ? 1 : 0 })); return;
    }
    setManttoData(p => ({ ...p, [name]: value }));
    if (name === "agent_ip" && value === "") setIpValid(true);
    if (name === "location_lat" && value === "") setLatValid(true);
    if (name === "location_lon" && value === "") setLonValid(true);
  };

  useEffect(() => {
    if (!ManttoData) return;
    const invalid = ManttoData.host === "" || ManttoData.name === "" ||
      !IpValid || !LatValid || !LonValid ||
      ManttoData.agent_ip === "" || ManttoData.agent_ip == null ||
      ManttoData.location_lat === "" || ManttoData.location_lon === "" ||
      ManttoData.groupids.length === 0;
    setDisabled(invalid);
  }, [ManttoData]);

  const changeMultiOption = (option, index, titulo) => {
    if (titulo === "statusConf") setTechFilter(option);
    if (titulo === "groups_catalog") setGroupFilter(option);
    if (titulo === "subgroups_catalog") setZoneFilter(option);
  };

  const handleStatus = (option) => {
    const next = statusFilter.includes(option)
      ? statusFilter.filter(v => v !== option)
      : [...statusFilter, option];
    setStatusFilter(next);
  };
  const handleAck = (option) => {
    const next = ackFilter.includes(option)
      ? ackFilter.filter(v => v !== option)
      : [...ackFilter, option];
    setAckFilter(next);
  };
  const handleSeverity = (option) => {
    const next = severityFilter.includes(option)
      ? severityFilter.filter(v => v !== option)
      : [...severityFilter, option];
    setSeverityFilter(next);
  };
  const handleTicket = (option) => {
    const next = ticketFilter.includes(option)
      ? ticketFilter.filter(v => v !== option)
      : [...ticketFilter, option];
    setTicketFilter(next);
  };
  const handleTipo = (option) => {
    const next = tipoFilter.includes(option)
      ? tipoFilter.filter(v => v !== option)
      : [...tipoFilter, option];
    setTipoFilter(next);
  };

  // ── UI helpers ──
  const FilterBtn = ({ active, onClick, children, color = 'gray' }) => {
    const map = {
      green: { bg: active ? '#d1fae5' : '#fff', col: active ? '#057a55' : '#334155', bd: active ? '#a7f3d0' : '#e2e8f0' },
      pink: { bg: active ? '#fce7f3' : '#fff', col: active ? '#db2777' : '#334155', bd: active ? '#fbcfe8' : '#e2e8f0' },
      gray: { bg: active ? '#f1f5f9' : '#fff', col: active ? '#475569' : '#334155', bd: active ? '#cbd5e1' : '#e2e8f0' },
      purple: { bg: active ? '#ede9fe' : '#fff', col: active ? '#7e3af2' : '#334155', bd: active ? '#c4b5fd' : '#e2e8f0' },
      amber: { bg: active ? '#fef3c7' : '#fff', col: active ? '#d97706' : '#334155', bd: active ? '#fde68a' : '#e2e8f0' },
      blue: { bg: active ? '#e8f0fe' : '#fff', col: active ? '#1a56db' : '#334155', bd: active ? '#c3dafe' : '#e2e8f0' },
    };
    const s = map[color];
    return (
      <button onClick={onClick} style={{
        background: s.bg, color: s.col, border: `1px solid ${s.bd}`,
        borderRadius: 5, padding: '4px 9px', fontSize: 10, fontWeight: 500,
        cursor: 'pointer', transition: 'all .12s', outline: 'none', fontFamily: 'inherit',
        display: 'flex', alignItems: 'center', gap: 4
      }}>
        {children}
      </button>
    );
  };

  const SectionLabel = ({ children }) => (
    <div style={{
      fontSize: 9, fontWeight: 600, color: '#64748b',
      textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 5
    }}>
      {children}
    </div>
  );

  const Divider = () => <div style={{ height: 1, background: '#f1f5f9', margin: '1px 0' }} />;

  // ── RENDER ──
  // El componente ya vive dentro de monitor-panel-filter-body
  // NO usa position:absolute propio — fluye dentro del contenedor padre
  return (
    <>
      <style>{`
        .fp-inner-scroll::-webkit-scrollbar { width: 3px; }
        .fp-inner-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
        .fp-ms .label-GS { display: none !important; }
        .fp-fbtn:hover { opacity: .85; }
      `}</style>

      {/* 
        Sin wrapper de posicionamiento — el padding/layout lo maneja
        monitor-panel-filter-body a través de su CSS existente.
        Solo añadimos el scroll interno si el contenido es largo.
      */}
      <div
        className="fp-inner-scroll"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          padding: '8px 2px',
          overflowY: 'auto',
          height: '100%'
        }}
        onMouseDown={handleMouseDown}
      >

        {/* Buscar */}
        <div>
          <SectionLabel>Buscar Afiliación/IP</SectionLabel>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 6,
            background: '#f1f5f9', border: '1px solid #e2e8f0',
            borderRadius: 6, padding: '5px 8px'
          }}>
            <svg width="11" height="11" viewBox="0 0 14 14" fill="none">
              <circle cx="6" cy="6" r="4.5" stroke="#94a3b8" strokeWidth="1.3" />
              <line x1="9.5" y1="9.5" x2="12.5" y2="12.5" stroke="#94a3b8" strokeWidth="1.3" strokeLinecap="round" />
            </svg>
            <input
              name="search"
              value={searchTerm}
              onChange={handleChange}
              placeholder="IP, nombre..."
              style={{
                border: 'none', outline: 'none', background: 'transparent',
                fontSize: 10, color: '#334155', width: '100%', fontFamily: 'inherit'
              }}
            />
          </div>
        </div>

        <Divider />

        {/* Tecnología */}
        <div className="fp-ms">
          <SectionLabel>{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</SectionLabel>
          <MultiSelector
            placeholder={'Seleccionar tecnologías...'}
            opGeneral={true} txtOpGen={''}
            opt_de={techFilter.map(item => item.id)}
            origen={'Admin'} data={technologies_catalog}
            loading={false} titulo='statusConf'
            selectFunction={changeMultiOption} index={0}
          />
        </div>

        <Divider />

        {/* Grupos */}
        <div className="fp-ms">
          <SectionLabel>{capitalizeFirstLetter(lang[languaje]['grupos'])}</SectionLabel>
          <MultiSelector
            placeholder={'Seleccionar grupos...'}
            opGeneral={false} txtOpGen={''}
            opt_de={groupFilter.map(item => item.id)}
            origen={'Admin'} data={groups_catalog}
            loading={false} titulo='groups_catalog'
            selectFunction={changeMultiOption} index={0}
          />
        </div>

        <Divider />

        {/* Zona / Municipio */}
        <div className="fp-ms">
          <SectionLabel>
            {capitalizeFirstLetter(lang[languaje]['zona'])} / {capitalizeFirstLetter(lang[languaje]['municipio'])}
          </SectionLabel>
          <MultiSelector
            placeholder={'Seleccionar zonas...'}
            opGeneral={true} txtOpGen={''}
            opt_de={zoneFilter.map(item => item.id)}
            origen={'Admin'} data={zona_catalog}
            loading={false} titulo='subgroups_catalog'
            selectFunction={changeMultiOption} index={0}
          />
        </div>

        <Divider />

        {/* Estatus */}
        <div>
          <SectionLabel>Estatus</SectionLabel>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            <FilterBtn active={statusFilter.includes('ok')} onClick={() => handleStatus('ok')} color="green">
              Conectado
            </FilterBtn>
            <FilterBtn active={statusFilter.includes('offline')} onClick={() => handleStatus('offline')} color="pink">
              Desconectado
            </FilterBtn>
            <FilterBtn active={statusFilter.includes('unknown')} onClick={() => handleStatus('unknown')} color="gray">
              Desconocido
            </FilterBtn>
          </div>
        </div>

        <Divider />

        {/* Tipo de incidencia */}
        <div>
          <SectionLabel>Tipo de incidencia</SectionLabel>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            <FilterBtn active={ackFilter.includes('except')} onClick={() => handleAck('except')} color="purple">
              <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                <path d="M6 1L11 10H1L6 1Z" stroke="currentColor" strokeWidth="1.2" fill="none" />
                <line x1="6" y1="4.5" x2="6" y2="7" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
              </svg>
              Excepción
            </FilterBtn>
            <FilterBtn active={ackFilter.includes('mtto')} onClick={() => handleAck('mtto')} color="amber">
              <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
                  fill="currentColor" stroke="currentColor" strokeWidth=".4" strokeLinejoin="round" />
              </svg>
              Mantenimiento
            </FilterBtn>
          </div>
        </div>

        <Divider />

        {/* Mostrar Capa */}
        <div>
          <SectionLabel>Mostrar capa</SectionLabel>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            <FilterBtn active={showCorrelationsFO} onClick={() => setShowCorrelationsFO(!showCorrelationsFO)} color="blue">
              Fibra Óptica
            </FilterBtn>
            <FilterBtn active={showCorrelationsMO} onClick={() => setShowCorrelationsMO(!showCorrelationsMO)} color="blue">
              Microonda
            </FilterBtn>
          </div>
        </div>

        {/* Aplicar / Limpiar */}
        {/* <div style={{ display: 'flex', gap: 6, marginTop: 4, paddingBottom: 4 }}>
          <button style={{
            flex: 1, background: '#1a56db', border: 'none',
            borderRadius: 6, color: '#fff', fontSize: 10,
            fontWeight: 500, padding: '6px 0', cursor: 'pointer', fontFamily: 'inherit'
          }}>
            Aplicar
          </button>
          <button onClick={handleClearFilters} style={{
            flex: 1, background: '#f1f5f9', border: '1px solid #e2e8f0',
            borderRadius: 6, color: '#64748b', fontSize: 10,
            fontWeight: 500, padding: '6px 0', cursor: 'pointer', fontFamily: 'inherit'
          }}>
            Limpiar
          </button>
        </div> */}

      </div>
    </>
  );
};

export default FilterPanel;